import React, { useEffect, useMemo } from "react";
import iso from "../../../assets/imgs/iso.webp";
import risingstar from "../../../assets/imgs/risingstar-logo.webp";
import microsoft from "../../../assets/imgs/microsoft.webp";
import { useIsOnline } from "react-use-is-online";
import Fcontact from "../../Shared/Fcontact";
import { useLocation } from "react-router";
import whiteLogo from "../../../assets/imgs/rc_white-logo.png";
import './css/Footer.css'

const Footer = () => {
  const { isOnline, isOffline, error } = useIsOnline();
  const googleTranslateElementInit = () => {
    if (isOnline) {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "ar,en,de,es,nl,da,sv,fr,no,it",
          autoDisplay: false,
        },
        "google_translate_element"
      );
    }
  };

  const location = useLocation();

  const isContactUs = useMemo(() => {
    return location.pathname.includes('contact-us') || location.pathname.includes('thank_you');
  },[location])

  useEffect(() => {
    if (isOnline) {

      // Initialize Google Translate after 5 Seconds
      let timer = setTimeout( function() {

        var addScript = document.createElement("script");
        addScript.setAttribute(
          "src",
          "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        );
        document.body.appendChild(addScript);
        window.googleTranslateElementInit = googleTranslateElementInit;

      }, 5000 );

      // Clear the timer after initializing Google Translate
      return () => clearTimeout( timer );
    }
  }, [isOnline]);

  return (
    <div>
      {!isContactUs ? <Fcontact policy={false} /> : ''}
      <footer className="footer-section">
        <div className="container">
          <div className="footer-content pb-3">

            <div class="row">
                <div class="col-md-12 col-xl-10 col-lg-10 mb-2">
                    <div class="row">
                        <div class="col-md-4  mb-4">
                            <div class="footer-logo">
                                <img src={whiteLogo} alt="nonprofit fundraising solutions" width="147" height="102" />
                                </div>
                            <div class="footerContact mt-4">
                                <div class="footer-widget">
                                    <div class="footer-widget-heading"><h6 role="heading">Phone No.: </h6><a aria-label="Phone Pumber +1-954.317.3944" href="tel:+1-954.317.3944">+1-954.317.3944</a></div><div class="footer-widget-heading"><h6 role="heading">Email Id: </h6><a aria-label="Email Id : info@rightcause.net" href="mailto:info@rightcause.net">info@rightcause.net</a></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-8">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="footerLink">
                                        <h6 role="heading">Where to Find Us</h6>
                                        <strong role="heading">INDIANA:</strong><p class="office-address">

                                            201 N Illinois Street,<br /> 16th Floor - South Tower<br />Indianapolis, IN 46204<br />United States
                                        </p>
                                        <strong role="heading">AUSTRALIA:</strong>
                                        <p class="office-address">8 Parramatta Square, Level 49<br />10 Darcy Street<br />Parramatta, NSW 2150</p>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 mb-4">
                                    <div class="footerLink"><h6 role="heading">Insights</h6><ul><li><a href="/insights" title="Blogs">Blogs</a></li><li><a href="/insights" title="Webinars">Webinars</a></li><li><a href="/insights" title="Videos">Videos</a></li><li><a href="/insights" title="Case Studies">Case Studies &amp; eBook</a></li></ul></div>

                                    <div class="footerLink mt-3 pt-1"><h6 role="heading">Solutions</h6><ul><li><a href="solutions/grants-management-solution" title="Grants Management Solution">Grants Management Solution</a></li><li><a href="solutions/donation-management-system" title="Grants Management Solution">Donation Management System</a></li></ul></div>
                                </div>
                            
                            </div>    
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-xl-2 col-lg-2 mb-4">
                    <div class="f-award-logo text-md-center">
                        <img alt="Microsoft Solution Partner" width="157" height="88" src={microsoft} />
                        <img alt="ISO 27001:2013" width="157" height="88" src={iso} />
                        <img alt="Risingstar Logo" width="157" height="88" src={risingstar} />
                    </div>
                </div>
            </div>
          
          </div>
        </div>
        <div className="subFooter">
                    <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-12">
                        <div className="copywrightTxt">
                            © Right Cause. All rights reserved.
                        </div>
                    </div>
                </div>
                </div>
            </div>
      </footer>
    </div>
  );
};

export default Footer;
